import type {Nil} from '../../types'
import {assertNonNil} from '../assert'

export const isEqual =
  <T>(a: T) =>
  (b: T) =>
    a === b
export const negate = (v: (...args: any[]) => boolean) => {
  return (...args: any[]) => !v(...args)
}
export const pluck =
  <Field extends string>(field: Field) =>
  <Obj extends Partial<Record<Field, unknown>>>(obj: Obj) =>
    assertNonNil(obj[field]) as Exclude<Obj[Field], Nil>

export const pluckMaybe =
  <Field extends string>(field: Field) =>
  <Obj extends Partial<Record<Field, unknown>>>(obj: Obj): Obj[Field] =>
    obj[field]
